import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';
import IntlPolyfill from 'intl';
import 'intl/locale-data/jsonp/pt-BR';

let DateTimeFormatptBR = null;
if (areIntlLocalesSupported(['pt-BR'])) {
    const { DateTimeFormat } = global.Intl;
    DateTimeFormatptBR = DateTimeFormat;
} else {
    const { DateTimeFormat } = IntlPolyfill;
    DateTimeFormatptBR = DateTimeFormat;
}

const DatePickerCustom = (props) => {
    const {
        value,
        onChange,
        openToYearSelection,
        required,
        errorText,
        floatingLabelText,
    } = props;

    return (
        <DatePicker
            required={required}
            errorText={errorText}
            DateTimeFormat={DateTimeFormatptBR}
            floatingLabelText={floatingLabelText}
            onChange={(n, date) => onChange(date)}
            openToYearSelection={openToYearSelection}
            firstDayOfWeek={0}
            formatDate={new DateTimeFormatptBR('pt-BR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            }).format}
            value={value}
        />
    );
};

DatePickerCustom.defaultProps = {
    value: new Date(),
    errorText: '',
};

DatePickerCustom.propTypes = {
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    openToYearSelection: PropTypes.bool.isRequired,
    required: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    floatingLabelText: PropTypes.string.isRequired,
};

export default DatePickerCustom;
